import React, { useEffect, useState } from "react";

import { getVSIFileIcon } from "file-extension-icon-js";

import { Badge, Rate, Menu, Dropdown, List, message, Checkbox } from "antd";

import services from "../../services";

import {
  validarVisualizar,
  validarSePassouDaDataDeValidade,
  validarSePassouDaDataDeValidadeArquivo,
  validarData,
  getAdobeFileIcon,
  getIconesExtensao,
} from "../../services/utils";

import TableHeader from "../Table/Header";
import TablePagination from "../Table/Pagination";
import RowDragInDrop from "../Table/RowDragInDrop";

import IconeArquivos from "../IconeArquivos";

import favoritoSvg from "../../assets/icons/iconFavoritado.svg";
import pastaSvg from "../../assets/icons/pastaIcone.svg";
import menuAbrir from "../../assets/iconsMenu/menuAbrir.svg";
import menuInfo from "../../assets/iconsMenu/menuInfo.svg";
import menuCompartilhar from "../../assets/iconsMenu/menuCompartilhar.svg";
import menuCopiar from "../../assets/iconsMenu/menuCopiar.svg";
import menuEditar from "../../assets/iconsMenu/menuEditar.svg";
import menuFavorito from "../../assets/iconsMenu/menuFavorito.svg";
import menuMover from "../../assets/iconsMenu/menuMover.svg";
import menuRemover from "../../assets/iconsMenu/menuRemover.svg";
import menuRenomear from "../../assets/iconsMenu/menuRenomear.svg";
import menuRemoverLink from "../../assets/icons/iconRemoverLink.svg";
import iconLinkSvg from "../../assets/icons/iconLink.svg";
import iconDownloadSvg from "../../assets/icons/iconDownload.svg";
import IcTresPontos from "../../assets/icons/iconeTresPontinhos.svg";
import "./styles.scss";
import { trackPromise } from "react-promise-tracker";
import { listarPastasPorFiltro } from "../../services/http/pastaService";
import lang from "../../assets/idioma/idiomas";

const ListagemPastasArquivos = ({
  setAtividadeRecenteSelecionada,
  atividadeRecenteSelecionada,
  enviaIdPastaPai,
  setEnviaIdPastaPai,
  data,
  mudarPagina,
  buscarPastasFilhas,
  showInfo,
  favoritar,
  showEditar,
  showRenomear,
  removerItem,
  IsAdmin,
  downloadFile,
  gerarLinkunico,
  handleRemoverFavorito,
  mostrarListagemLinks,
  handleRemoverLink,
  showModalVisualizar,
  atualizarPastasDragInDrop,
  showModalCompartilhar,
  showModalCopiar,
  showModalMover,
  mostrarListagemFavoritos,
  handleAlterarClassificacao,
  selecionarItemParaDownload,
  marcarTodosItens,
  isSelectAll,
  itemsSelecionadosMover,
  setItensSelecionados,
  colunaPadrao,
  // clicarColuna,
  setOrdenacao,
  ordenacao,
  treeData,
}) => {
  const isMidia = services.storage.isMidia();
  //const tabelaColunas = [<img src={favoritoSvg} />, <Checkbox checked={isSelectAll} onClick={(event) => marcarTodosItens(event.target.checked, data?.lista)} type='checkbox'>Selecionar</Checkbox>, 'Nome', 'Autor', 'Tamanho', 'Tipo', 'Data de inclusão', 'Data validade',  'Data início', 'Data fim'];
  const tabelaColunas = [
    <img src={favoritoSvg} />,
    <Checkbox
      checked={isSelectAll}
      onClick={(event) => marcarTodosItens(event.target.checked, data?.lista)}
      type="checkbox"
    >
      {/* Selecionar */}
    </Checkbox>,
    lang.Nome,
    lang.Classificacao,
    // "Autor",
    lang.Tamanho,
    lang.Tipo,
    // "Data de inclusão",
    lang.Data_de_Inicio,
    lang.Data_Fim,
    mostrarListagemLinks && "Data de Compartilhamento",
  ];

  const formatarData = (value) => {
    if (value) {
      const data = new Date(value);
      var dataFormatda = data.toLocaleDateString("pt-BR", { timeZone: "UTC" });
      return dataFormatda;
    }
  };

  const formatarDataParaArquivo = (value) => {
    if (value) {
      const data = new Date(value);
      var dataComHora = data.toLocaleString("pt-BR");

      dataComHora = dataComHora.replace(",", "");

      return dataComHora;
    }
  };

  const visualizacao = (item) => {
    let extensaoValida = validarVisualizar(item.extensao);

    if (
      extensaoValida != "nao-suportado" &&
      !validarSePassouDaDataDeValidadeArquivo(
        item.dataVencimentoInicial,
        item.dataVencimentoFinal,
        IsAdmin
      )
    ) {
      return (
        <>
          <Menu.Item
            key="1"
            onClick={() => showModalVisualizar(item)}
            icon={<img src={menuAbrir} />}
          >
            Visualizar
          </Menu.Item>
          <hr className="linha-menu" />
        </>
      );
    }
  };

  const showMenu = (id, tipo, item) => {
    return (
      <div className="menu">
        <Menu>
          {tipo == "pasta" &&
          !validarSePassouDaDataDeValidade(item.dataVencimento) ? (
            <>
              <Menu.Item
                key="1"
                onClick={() => buscarPastasFilhas(id, tipo, item.nome)}
                icon={<img src={menuAbrir} />}
              >
                {lang.Abrir}
              </Menu.Item>
              <hr className="linha-menu" />
            </>
          ) : (
            <>{visualizacao(item)}</>
          )}
          <Menu.Item
            key="2"
            onClick={() => showInfo(id, tipo)}
            icon={<img src={menuInfo} />}
          >
            {lang.Info}
          </Menu.Item>
          {item.ehFavorito ? (
            <Menu.Item
              key="3"
              onClick={() => handleRemoverFavorito(item)}
              icon={<img src={menuFavorito} />}
            >
              {lang.Remover_favorito}
            </Menu.Item>
          ) : (
            <Menu.Item
              key="3"
              onClick={() => favoritar(item)}
              icon={<img src={menuFavorito} />}
            >
              {lang.Favoritos}
            </Menu.Item>
          )}
          <hr className="linha-menu" />
          {!validarSePassouDaDataDeValidade(item.dataVencimento) ? (
            <Menu.Item
              key="4"
              onClick={() => downloadFile(item)}
              icon={<img src={iconDownloadSvg} />}
            >
              {lang.Fazer_download}...
            </Menu.Item>
          ) : null}
          {mostrarListagemLinks && (
            <Menu.Item
              key="5"
              onClick={() => {
                gerarLinkunico(item);
              }}
              icon={<img src={iconLinkSvg} />}
            >
              {lang.Gerenciar_link}
            </Menu.Item>
          )}
          {mostrarListagemLinks == false &&
            !validarData(item.dataVencimento) && (
              <Menu.Item
                key="5"
                onClick={() => {
                  gerarLinkunico(item);
                }}
                icon={<img src={iconLinkSvg} />}
              >
                {lang.Obter_link}
              </Menu.Item>
            )}
          {mostrarListagemLinks && (
            <Menu.Item
              key="6"
              onClick={() => {
                handleRemoverLink(item.id);
              }}
              icon={<img src={menuRemoverLink} />}
            >
              {lang.Remover_link}
            </Menu.Item>
          )}
          {item.tipo == 0 && !mostrarListagemFavoritos ? (
            <Menu.Item
              key="7"
              onClick={() => {
                showModalCompartilhar(item);
              }}
              icon={<img src={menuCompartilhar} />}
            >
              {lang.Compartilhar}
            </Menu.Item>
          ) : null}
          {isMidia && (
            <>
              <hr className="linha-menu" />
              <Menu.Item
                key="8-midia"
                onClick={() => showEditar(id, tipo)}
                icon={<img src={menuEditar} />}
              >
                {lang.Editar}
              </Menu.Item>
            </>
          )}
          {IsAdmin.toLocaleLowerCase() == "true" && (
            <>
              <hr className="linha-menu" />
              <Menu.Item
                key="8"
                onClick={() => showEditar(id, tipo)}
                icon={<img src={menuEditar} />}
              >
                {lang.Editar}
              </Menu.Item>
              <Menu.Item
                key="9"
                onClick={() => showRenomear(id, tipo)}
                icon={<img src={menuRenomear} />}
              >
                {lang.Renomear}
              </Menu.Item>
              <>
                <Menu.Item
                  key="10"
                  icon={<img src={menuMover} />}
                  onClick={() => showModalMover(item)}
                >
                  {lang.Mover}
                </Menu.Item>
                <Menu.Item
                  key="11"
                  icon={<img src={menuCopiar} />}
                  onClick={() => showModalCopiar(item)}
                >
                  {lang.Copiar}
                </Menu.Item>
              </>
              <hr className="linha-menu" />
              <Menu.Item
                key="12"
                onClick={() => removerItem(id, tipo)}
                icon={<img src={menuRemover} />}
              >
                {lang.Remover}
              </Menu.Item>
            </>
          )}
        </Menu>
      </div>
    );
  };

  // useEffect(() => {
  //   if (atividadeRecenteSelecionada) {
  //     buscarPastasFilhas(
  //       enviaIdPastaPai?.idPastaPai,
  //       enviaIdPastaPai?.tipo,
  //       enviaIdPastaPai?.nome
  //     );
  //     setAtividadeRecenteSelecionada(false);
  //   }
  // }, []);

  const handleEntrarVisualizar = (item) => {
    if (item.tipo == 0) {
      buscarPastasFilhas(item.id, "pasta", item.nome);
    }

    if (item.tipo == 1) {
      if (validarVisualizar(item.extensao) !== "nao-suportado") {
        showModalVisualizar(item);
      } else {
        message.warning(lang.Extensao_nao_tem_suporte_a_visualizacao);
      }
    }
  };

  // const preImagemArquivo = (item) => {
  //   const extensao = item.extensao ?? item.nome.split(".")[1];

  //   let nomeArquivo =
  //     !item.nome.includes(".") && extensao != null
  //       ? `${item.nome}.${extensao}`
  //       : item.nome;

  //   if (item.urlPreview) {
  //     return (
  //       <img
  //         src={item.urlPreview}
  //         className={
  //           validarSePassouDaDataDeValidade(item.dataVencimento)
  //             ? "pasta-arquivo-pos-validade "
  //             : ""
  //         }
  //       />
  //     );
  //   } else {
  //     return (
  //       <div style={{ maxHeight: "1.5rem", maxWidth: "1.5rem" }}>
  //         <img
  //           src={getVSIFileIcon(nomeArquivo) }
  //           className={
  //             validarSePassouDaDataDeValidade(item.dataVencimento)
  //               ? "pasta-arquivo-pos-validade "
  //               : ""
  //           }
  //         />
  //       </div>
  //     );
  //   }
  // };

  const preImagemArquivo = (item) => {
    const extensao = item.extensao ?? item.nome.split(".")[1];
    let nomeArquivo =
      !item.nome.includes(".") && extensao != null
        ? `${item.nome}.${extensao}`
        : item.nome;

    if (item.urlPreview) {
      return (
        <img
          src={item.urlPreview}
          className={
            validarSePassouDaDataDeValidade(item.dataVencimento)
              ? "pasta-arquivo-pos-validade"
              : ""
          }
        />
      );
    } else {
      return (
        <div style={{ maxHeight: "1.5rem", maxWidth: "1.5rem" }}>
          <img
            src={getIconesExtensao(extensao)}
            className={
              validarSePassouDaDataDeValidade(item.dataVencimento)
                ? "pasta-arquivo-pos-validade"
                : ""
            }
          />
        </div>
      );
    }
  };

  const handleChangeClassificacao = (item, e) => {
    handleAlterarClassificacao(item, e);
  };

  return (
    <>
      <div className="row">
        <table className="table table-borderless col-lg-12">
          <thead>
            <tr>
              {tabelaColunas.length > 0 &&
                tabelaColunas.map((coluna, index) => (
                  <th
                    onClick={() => {
                      // clicarColuna(coluna);
                      coluna == lang.Nome &&
                        setOrdenacao(
                          ordenacao == "extensao asc, nomeOrdenacao asc"
                            ? "extensao desc, nomeOrdenacao desc"
                            : "extensao asc, nomeOrdenacao asc"
                        );
                      coluna == lang.Classificacao &&
                        setOrdenacao(
                          ordenacao == "classificacao asc"
                            ? "classificacao desc"
                            : "classificacao asc"
                        );
                      // coluna == "Autor" &&
                      //   setOrdenacao(
                      //     ordenacao == "autor asc" ? "autor desc" : "autor asc"
                      //   );
                      coluna == lang.Tamanho &&
                        setOrdenacao(
                          ordenacao == "tamanhoEmBytes  asc"
                            ? "tamanhoEmBytes  desc"
                            : "tamanhoEmBytes  asc"
                        );
                      coluna == lang.Tipo &&
                        setOrdenacao(
                          ordenacao == "extensao asc"
                            ? "extensao desc"
                            : "extensao asc"
                        );
                      // coluna == "Data de inclusão" &&
                      //   setOrdenacao(
                      //     ordenacao == "DataInclusao asc"
                      //       ? "DataInclusao desc"
                      //       : "DataInclusao asc"
                      //   );
                      coluna == lang.Data_de_Inicio &&
                        setOrdenacao(
                          ordenacao == "DataVencimentoInicial asc"
                            ? "DataVencimentoInicial desc"
                            : "DataVencimentoInicial asc"
                        );
                      coluna == lang.Data_Fim &&
                        setOrdenacao(
                          ordenacao == "DataVencimentoFinal asc"
                            ? "DataVencimentoFinal desc"
                            : "DataVencimentoFinal asc"
                        );
                      coluna == "Data de Compartilhamento" &&
                        mostrarListagemLinks &&
                        setOrdenacao(
                          ordenacao == "DataCompartilhamento asc"
                            ? "DataCompartilhamento desc"
                            : "DataCompartilhamento asc"
                        );
                    }}
                    style={{ cursor: "pointer" }}
                    key={index}
                  >
                    {" "}
                    {coluna}
                    {coluna === lang.Nome &&
                      ordenacao === "extensao desc, nomeOrdenacao desc" && (
                        <span>&#9650;</span>
                      )}
                    {coluna === lang.Nome &&
                      ordenacao === "extensao asc, nomeOrdenacao asc" && (
                        <span>&#9660;</span>
                      )}
                    {coluna === lang.Classificacao &&
                      ordenacao === "classificacao desc" && (
                        <span>&#9650;</span>
                      )}
                    {coluna === lang.Classificacao &&
                      ordenacao === "classificacao asc" && <span>&#9660;</span>}
                    {/* {coluna === "Autor" && ordenacao === "autor desc" && (
                      <span>&#9650;</span>
                    )}
                    {coluna === "Autor" && ordenacao === "autor asc" && (
                      <span>&#9660;</span>
                    )} */}
                    {coluna === lang.Tamanho &&
                      ordenacao === "tamanhoEmBytes  desc" && (
                        <span>&#9650;</span>
                      )}
                    {coluna === lang.Tamanho &&
                      ordenacao === "tamanhoEmBytes  asc" && (
                        <span>&#9660;</span>
                      )}
                    {coluna === lang.Tipo && ordenacao === "extensao desc" && (
                      <span>&#9650;</span>
                    )}
                    {coluna === lang.Tipo && ordenacao === "extensao asc" && (
                      <span>&#9660;</span>
                    )}
                    {/* {coluna === "Data de inclusão" &&
                      ordenacao === "DataInclusao desc" && <span>&#9650;</span>}
                    {coluna === "Data de inclusão" &&
                      ordenacao === "DataInclusao asc" && <span>&#9660;</span>} */}
                    {coluna === lang.Data_de_Inicio &&
                      ordenacao === "DataVencimentoInicial desc" && (
                        <span>&#9650;</span>
                      )}
                    {coluna === lang.Data_de_Inicio &&
                      ordenacao === "DataVencimentoInicial asc" && (
                        <span>&#9660;</span>
                      )}
                    {coluna === lang.Data_Fim &&
                      ordenacao === "DataVencimentoFinal desc" && (
                        <span>&#9650;</span>
                      )}
                    {coluna === lang.Data_Fim &&
                      ordenacao === "DataVencimentoFinal asc" && (
                        <span>&#9660;</span>
                      )}
                    {coluna === "Data de Compartilhamento" &&
                      ordenacao === "DataCompartilhamento desc" &&
                      mostrarListagemLinks && <span>&#9650;</span>}
                    {coluna === "Data de Compartilhamento" &&
                      ordenacao === "DataCompartilhamento asc" &&
                      mostrarListagemLinks && <span>&#9660;</span>}
                  </th>
                ))}
            </tr>
          </thead>
          <tbody>
            {(!data?.lista || data?.lista.length === 0) && (
              <tr>
                <td colSpan="7"> Sem Registros </td>
              </tr>
            )}
            {data?.lista &&
              data?.lista?.map((item, index) => (
                <RowDragInDrop
                  treeData={treeData}
                  key={index}
                  data={item}
                  setItensSelecionados={setItensSelecionados}
                  itensSelecionados={itemsSelecionadosMover}
                  atualizarPastasDragInDrop={atualizarPastasDragInDrop}
                >
                  <td>
                    {item.ehFavorito ? (
                      <svg
                        width="19"
                        height="16"
                        viewBox="0 0 19 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        onClick={() => {
                          handleRemoverFavorito(item);
                        }}
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M9.13041 15.8983C9.2405 15.9652 9.36877 16.0005 9.49969 16C9.63094 16.0003 9.75945 15.9645 9.86959 15.8971C11.596 14.8398 13.2147 13.6332 14.7047 12.2929C17.4964 9.75541 18.9415 7.34873 19 5.1426V5.13969V5.00483C18.9999 3.95944 18.6533 2.94032 18.0088 2.09048C17.3643 1.24064 16.4542 0.602738 15.4063 0.266297C14.3584 -0.070143 13.2253 -0.0882356 12.166 0.214559C11.1066 0.517354 10.1743 1.12584 9.49969 1.95462C8.82499 1.126 7.89255 0.517697 6.83322 0.215079C5.77388 -0.087539 4.64081 -0.0692876 3.59301 0.267272C2.54522 0.603832 1.63528 1.24181 0.990889 2.09168C0.346496 2.94155 -6.44033e-06 3.96065 0 5.00599V5.13446V5.14376C0.0584691 7.34814 1.50357 9.75483 4.29532 12.2941C5.78529 13.6344 7.40395 14.841 9.13041 15.8983Z"
                          fill="#828282"
                        />
                      </svg>
                    ) : (
                      <svg
                        width="19"
                        height="16"
                        viewBox="0 0 19 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        onClick={() => favoritar(item)}
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M9.13041 15.8983C9.2405 15.9652 9.36877 16.0005 9.49969 16C9.63094 16.0003 9.75945 15.9645 9.86959 15.8971C11.596 14.8398 13.2147 13.6332 14.7047 12.2929C17.4964 9.75541 18.9415 7.34873 19 5.1426V5.13969V5.00483C18.9999 3.95944 18.6533 2.94032 18.0088 2.09048C17.3643 1.24064 16.4542 0.602738 15.4063 0.266297C14.3584 -0.070143 13.2253 -0.0882356 12.166 0.214559C11.1066 0.517354 10.1743 1.12584 9.49969 1.95462C8.82499 1.126 7.89255 0.517697 6.83322 0.215079C5.77388 -0.087539 4.64081 -0.0692876 3.59301 0.267272C2.54522 0.603832 1.63528 1.24181 0.990889 2.09168C0.346496 2.94155 -6.44033e-06 3.96065 0 5.00599V5.13446V5.14376C0.0584691 7.34814 1.50357 9.75483 4.29532 12.2941C5.78529 13.6344 7.40395 14.841 9.13041 15.8983Z"
                          fill="#aaa"
                        />
                      </svg>
                    )}
                  </td>
                  <td className="d-flex justify-content-center">
                    <Checkbox
                      checked={item.checked}
                      onChange={(e) =>
                        selecionarItemParaDownload(e.target.checked, item)
                      }
                    ></Checkbox>
                  </td>
                  <td onClick={() => handleEntrarVisualizar(item)}>
                    <span className="coluna-nome">
                      {item.tipo == 1 ? (
                        preImagemArquivo(item)
                      ) : (
                        <img
                          src={pastaSvg}
                          alt="pasta"
                          className={
                            validarSePassouDaDataDeValidade(item.dataVencimento)
                              ? "pasta-arquivo-pos-validade "
                              : ""
                          }
                        />
                      )}
                      <span title={item.nome}>{item.nome}</span>
                    </span>
                  </td>
                  <td>
                    {" "}
                    <Rate
                      className="svg-classificacao"
                      style={{ whiteSpace: "nowrap" }}
                      onChange={(e) => handleChangeClassificacao(item, e)}
                      value={item.classificacao}
                    />{" "}
                  </td>
                  {/* <td onClick={() => handleEntrarVisualizar(item)}>
                    {" "}
                    {item.autor}{" "}
                  </td> */}
                  <td onClick={() => handleEntrarVisualizar(item)}>
                    {" "}
                    {item.tamanho != 0 ? item.tamanho : " - "}{" "}
                  </td>
                  <td onClick={() => handleEntrarVisualizar(item)}>
                    {" "}
                    {item.tipo == 0 ? "Pasta" : item.extensao}{" "}
                  </td>
                  {/* <td onClick={() => handleEntrarVisualizar(item)}>
                    {" "}
                    {formatarData(item.dataInclusao)}{" "}
                  </td> */}
                  {/* <td onClick={() => handleEntrarVisualizar(item)}> {`${item.dataVencimento && !item.dataVencimento.includes('0001') ? formatarData(item.dataVencimento) : '-'}`} </td> */}
                  <td
                    className="coluna-inicial"
                    onClick={() => handleEntrarVisualizar(item)}
                  >
                    {`${
                      item.dataVencimentoInicial &&
                      !item.dataVencimentoInicial.includes("0001")
                        ? formatarDataParaArquivo(item.dataVencimentoInicial)
                        : "-"
                    }`}
                  </td>
                  <td onClick={() => handleEntrarVisualizar(item)}>
                    {" "}
                    {`${
                      item.dataVencimentoFinal &&
                      !item.dataVencimentoFinal.includes("0001")
                        ? formatarDataParaArquivo(item.dataVencimentoFinal)
                        : "-"
                    }`}{" "}
                  </td>
                  {mostrarListagemLinks && (
                    <td onClick={() => handleEntrarVisualizar(item)}>
                      {" "}
                      {`${
                        item.dataCompartilhamento &&
                        !item.dataCompartilhamento.includes("0001")
                          ? formatarDataParaArquivo(item.dataCompartilhamento)
                          : "-"
                      }`}{" "}
                    </td>
                  )}
                  {item.tipo != null && (
                    <td className="text-right">
                      <List.Item className="list-item">
                        <Dropdown.Button
                          trigger={["click"]}
                          className="button-list"
                          icon={<img src={IcTresPontos} alt="Ícone" />}
                          overlay={() =>
                            showMenu(
                              item.id,
                              item.tipo == 0 ? "pasta" : "arquivo",
                              item
                            )
                          }
                          placement="bottomLeft"
                        ></Dropdown.Button>
                      </List.Item>
                    </td>
                  )}
                </RowDragInDrop>
              ))}
          </tbody>
        </table>
      </div>
      <div>
        <TablePagination data={data} changePage={mudarPagina} />
      </div>
    </>
  );
};

export default ListagemPastasArquivos;
